import { SupportWrapper } from '../support/SupportStyles';
export const PolicyWrapper = SupportWrapper;
